import { Spinner } from 'components/design';
import OWContainer from 'styles/styled-components/ow-container';
import { CompanyOwnerForm } from '../components/company-owner-form';
import useController from '../controllers/add-company-owner-controller';

export const AddCompanyOwnerRoute = () => {
    const { formData, onSubmit, onCancel, onChange, isLoading, isAddCompanyOwnerLoading, errors } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <CompanyOwnerForm
                    formData={formData}
                    onSubmit={onSubmit}
                    onChange={onChange}
                    onCancel={onCancel}
                    isSaveLoading={isAddCompanyOwnerLoading}
                    errors={errors}
                />
            )}
        </OWContainer>
    );
};
